import { pushDataLayer } from '../index'
import { PageViewLayer } from '@component/dataLayer'

export default function PageViewDataLayer() {

  return (
    <PageViewLayer data={{
      'event': 'page_view',
      'page_type': 'homepage',
      'vertical': 'valuation',
      'vertical_type': 'valuation'
    }}></PageViewLayer>
  )
}

export const mapDataLayer = {

  checkbox(name, checked) {
    pushDataLayer(
      {
        'event': 'page_view',
        'vertical': 'valuation',
        'vertical_type': 'valuation',
        'page_type': 'search',
        'map_box_name': '{name}',
        'estimate_search': '{search|select to search|deselect to search}'
      },
      {
        name,
        search: checked
      }
    )
  },

  selectDropdown() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Search',
      'event_interaction': 'CTA',
      'event_type': 'valuation'
    })
    pushDataLayer({
      'event': 'ga4_event',
      'event_name': 'perform_search',
      'search_method': 'select_from_dropdown'
    })
  },

  trackClick() {
    pushDataLayer({
      'event': 'analytics_track',
      'event_journey': 'Property Valuation Track',
      'event_interaction': 'Estimates Map',
      'event_type': 'Track this property'
    })
  },

  mapChanged() {
    pushDataLayer({
      'vertical': 'valuation',
      'vertical_type': 'valuation',
      'event': 'page_view',
      'page_type': 'search'
    })
  }
}